import { CheckOutlined } from "@ant-design/icons";
import { message } from "antd";
import styled from "styled-components/macro";

export const MessageComponent = (mess) => {
  message.open({
    type: "success",
    content: (
      <Wrap>
        <CheckOutlined />
        {mess}
      </Wrap>
    ),
    className: "article-message",
    icon: <></>,
  });
};

export default MessageComponent;

const Wrap = styled.div`
  font-size: 16px;
  font-family: var(--roboto-500);
  line-height: 24px;
  color: #fff;
  svg {
    color: #fff;
  }
`;
